import {SelectedAnalyzer} from "../list-item";

export function isSelectedDoctorAssignable(
  selectedAnalyzer: SelectedAnalyzer | undefined,
  doctorId: number | undefined
): boolean {
  return selectedAnalyzer !== undefined
    && !(selectedAnalyzer.assignType === "DOCTOR" && selectedAnalyzer.doctorId === doctorId);
}
